import { FC, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { icons } from 'src/assets';
import { Box, Button, CircularProgress, Grid, Typography } from 'src/components/UI';
import { contractorsActions } from 'src/ducks/actions';
import { getContractorSelected } from 'src/ducks/contractors/selectors';
// import { getContractorsFilter } from 'src/ducks/filters/selector';
import { ContractorsContext } from '../../context';
import { dispatchTypes, MODAL_TYPE } from '../../context/types';
const ConfirmDeleteContractor: FC = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const contractor = useSelector(getContractorSelected)
    // const contractorsFilter = useSelector(getContractorsFilter())

    // const { selectedAffiliates } = contractorsFilter

    const { dispatch: dispatchContext } = useContext(ContractorsContext)

    const [loading, setLoading] = useState(false)

    const handleCancel = () => {
        dispatchContext({
            type: dispatchTypes.SET_VALUE, payload: {
                attr: 'modalType',
                value: MODAL_TYPE.EDIT
            }
        })
    }

    const handleDelete = () => {
        if (contractor?.id) {
            setLoading(true)
            dispatch(contractorsActions.deleteContractor({
                contractor: {
                    id: contractor.id,
                    name: contractor.name,
                }
            }, (succ) => {
                if (succ) {
                    dispatchContext({
                        type: dispatchTypes.SET_VALUE, payload: {
                            attr: 'modalOpen',
                            value: false
                        }
                    })
                    dispatch(
                        contractorsActions.fetchAllContractors({ searchParams: { search: '' } }, (su) => setLoading(false))
                    )
                    toast.success("Contractor deleted")
                    navigate('/contractors')
                } else {
                    setLoading(false)
                    toast.success("Error trying to delete contractor")
                }

            }))
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant='body1Bold'>{contractor?.name}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Typography >This action can't be undone. <br /> Are you sure you want to delete this contractor?</Typography>
            </Grid>
            <Grid item xs={6}>
                <Button
                    onClick={handleCancel}
                    fullWidth
                    disabled={loading}
                    variant='containedLight'>
                    No, Cancel
                </Button>
            </Grid>
            <Grid item xs={6}>
                {loading ? <Box display='flex' justifyContent='center'>
                    <CircularProgress size={30} />
                </Box> : (
                    <Button
                        onClick={handleDelete}
                        fullWidth
                        variant='containedError'
                        endIcon={<icons.Delete />}
                    >
                        Yes, Delete
                    </Button>
                )}
            </Grid>

        </Grid>
    )
}

export default ConfirmDeleteContractor;